<template>
    <div class="app-main non-out">
        <div class="top-bar">
            <el-input  v-model="searchVal" placeholder="输入手机号/抽奖码搜索" @change="search" style="width:240px">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>
        <!-- 商品列表 -->
        <el-card shadow="hover">
            <el-table :data="tableData"   height="545">
                <el-table-column prop="nickname"    label="名称"  align="center"></el-table-column>
                <el-table-column  prop="phone"      label="手机号" align="center"></el-table-column>
                <el-table-column  prop="flag"       label="获取途径" align="center"  >
                    <template slot-scope="scope"> 
                        <span v-if="scope.row.flag == 0">
                            分享获取
                        </span>
                        <span v-else-if="scope.row.flag == 1">
                            下单获取
                        </span>
                        <span  v-else-if="scope.row.flag == 2">
                            福利打卡获取
                        </span>
                        
                    </template>
                </el-table-column>
                <el-table-column  prop="code"       label="抽奖码" align="center"   > </el-table-column>
                 <el-table-column  prop="created_at" label="添加时间"  align="center"  show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span> {{_date(scope.row.created_at)}} </span>
                    </template>
                </el-table-column>
            </el-table>

             <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </el-card>
    </div>
</template>



<script>
import { wechat_luck_draw } from "@/api/market.js";
export default {
    data() {
        return {
            searchVal:'',
            tableData:[],
            page: 1,
            total: 0,
            size: 20
        }
    },
    methods: {
        search() {
             this.page = 1
             this.getData();
        },
        reloadData(page){
            this.page = page;
            this.getData();
        },
        getData() {
            let params = {
                page: this.page
            }
            
            if (this.searchVal != "") {
                params.search =  this.searchVal
            }
            wechat_luck_draw(params).then(res => {  
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size = res.data.per_page
                }
            })
        }
    },
    mounted(){
        this.getData()
    },
    activated() {
        this.getData()
    },

}
</script>
<style scoped>
.input-icon {
    width: 14px;
    height: 14px;
    margin: 13px 0 0 5px;
}
</style>

